
import React from 'react';

export default function WhyChooseUsSection() {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-block px-4 py-2 bg-teal-100 text-teal-700 rounded-full text-sm font-semibold mb-6">
            Why Choose Us
          </div>
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-6"
            style={{ fontFamily: 'Poppins, sans-serif' }}
          >
            The <strong>TRex RE LLC</strong> Advantage
          </h2>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Cash Offers */}
          <div className="text-center">
            <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-money-dollar-circle-fill text-teal-600 text-4xl" aria-hidden="true"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Cash Offers</h3>
            <p className="text-gray-700">
              Get a fair cash offer within 24 hours. No waiting for bank approvals or financing
              contingencies.
            </p>
          </div>

          {/* No Repairs Needed */}
          <div className="text-center">
            <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-tools-fill text-teal-600 text-4xl" aria-hidden="true"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">No Repairs Needed</h3>
            <p className="text-gray-700">
              We buy houses in any condition. No need to spend time or money on repairs or renovations.
            </p>
          </div>

          {/* Fast Closings */}
          <div className="text-center">
            <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-time-fill text-teal-600 text-4xl" aria-hidden="true"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">Fast Closings</h3>
            <p className="text-gray-700">
              Close in as little as 7 days or on your preferred timeline. You choose the closing date.
            </p>
          </div>

          {/* No Commissions */}
          <div className="text-center">
            <div className="w-20 h-20 bg-teal-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <i className="ri-percent-fill text-teal-600 text-4xl" aria-hidden="true"></i>
            </div>
            <h3 className="text-xl font-bold text-gray-900 mb-3">No Commissions</h3>
            <p className="text-gray-700">
              No real estate agent commissions or hidden fees. What we offer is what you get.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
